import { configureStore } from "@reduxjs/toolkit"
import creatorReducer from "./slices/creatorSlice"
export const store = configureStore({
  reducer: {
    creator: creatorReducer,
  },
})
